import { FunctionComponent } from "react";
import { OneClickSubscribeModule } from "@bluebottlecoffee/design-system/components";
import { useAuth, useCart } from "@chordcommerce/react-autonomy";
import {
  DereferencedOneClickSubscribeModuleProps,
  toOneClickSubscribeModuleProps,
} from "../lib/transformers/one-click-subscribe-module";

export type OneClickSubscribeModuleWrapperProps = {
  moduleProps: DereferencedOneClickSubscribeModuleProps;
  lang: string;
};

export const OneClickSubscribeModuleWrapper: FunctionComponent<
  OneClickSubscribeModuleWrapperProps
> = ({ moduleProps, lang }) => {
  const { addSubscription } = useCart();
  const { isLoggedIn } = useAuth();

  const transformedProps = toOneClickSubscribeModuleProps(
    moduleProps,
    lang,
    isLoggedIn,
    addSubscription,
  );

  return <OneClickSubscribeModule {...transformedProps} />;
};
